// extracted by mini-css-extract-plugin
export default {"container":"LV-z","title":"MV-z","link":"NV-z"};